import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { loadTranslations } from "./assets/config/translations";
import { loadSettings } from "./assets/config/settings";
import addTuiWrapper from "./assets/config/tui-wrapper";

const start = async () => {
  const hostname = window.location.hostname;
  const match = /tui\.(se|dk|fi|no)/.exec(hostname);
  const brand = match ? match[1] : "se";

  const isEnglishPath = window.location.pathname.includes(
    "/customer-service/company-gift-card"
  );

  const language = isEnglishPath ? "gb" : brand;

  await loadSettings(hostname);
  await loadTranslations(language);
  await addTuiWrapper();


  ReactDOM.render(
    <App path="/*" market={brand} language={language} />,
    document.getElementById('root')
  );
}

start();
